import React, { useEffect, useRef, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { QRCodeCanvas } from 'qrcode.react';
import { toPng } from 'html-to-image';
import Hexapi from '../../utility/HexAPI/Hexapi';
import Loader from '../../components/loader/Loader';
import GetImage from '../../components/getimage/Getimage';
import LOGO_URL from '../../assets/logotrackhr.png'; // local asset — adjust path to where you place the file

import { BsExclamationCircle } from 'react-icons/bs';
import TutorialModal from '../../components/tutorialmodal/Tutorialmodal';

const QR_SIZE = 220;
const LOGO_SIZE = Math.round(QR_SIZE * 0.15); // logo diameter = 15% of QR width — safe with level "H" error correction
const AVATAR_SIZE = 96;
const AVATAR_BORDER = 6;

const AddTeamQrModal = ({
  show,
  onHide,
  empid,
  title = 'Add Team',
  username,
  orgname,
  appDownloadLink,
  userid,             // logged-in user id — needed by TutorialModal
  istutorialinfo ="AddSubordinate",     // identifies which tutorial/video to show — pass as prop
}) => {
  const [qrValue, setQrValue] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [youtubevideo, setYoutubevideo] = useState(false); // controls TutorialModal visibility

  const captureRef = useRef(null);

  const getdata = async () => {
    setLoading(true);
    setError('');
    setQrValue('');
    try {
      const obj = {
        query: `HRApp_Droid_Proc_User_GetQR @EmpID='{0}'`,
        queryArr: [`${empid}`],
      };

      const resp = await Hexapi(obj);
      console.log(resp, 'resp');

      const row = resp?.['']?.[0];
      const command = row?.command;
      console.log(row, 'row');

      if (command == 1) {
        const data = row?.qrcode;
        if (data) {
          setQrValue(data);
        } else {
          setError('QR data not found.');
        }
      } else {
        setError(row?.msg || 'Unable to fetch QR code.');
      }
    } catch (err) {
      console.error(err);
      setError('Failed to fetch QR code. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (show && empid) {
      getdata();
    }

    if (!show) {
      setQrValue('');
      setError('');
    }
  }, [show, empid]);

  if (!show) return null;

  return (
    <>
      <Modal centered show={show} onHide={onHide}>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>

          {/* Tutorial/help icon — opens the YouTube tutorial video modal */}
          {istutorialinfo ? (
            <span className="text-danger cur-point">
              <BsExclamationCircle
                style={{ fontSize: '24px', marginBottom: '4px', cursor: 'pointer' }}
                onClick={() => setYoutubevideo(true)}
              />
            </span>
          ) : (
            ''
          )}
        </Modal.Header>

      <Modal.Body
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '30px',
          gap: '20px',
          minHeight: '260px',
        }}
      >
        {loading && <Loader istext={true} />}

        {!loading && error && (
          <p style={{ color: '#c00', textAlign: 'center' }}>{error}</p>
        )}

        {!loading && !error && qrValue && (
          <>
            <div
              style={{
                position: 'relative',
                display: 'inline-block',
              }}
            >
              <div
                ref={captureRef}
                style={{
                  position: 'relative',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  backgroundColor: '#fff',
                  borderRadius: '16px',
                  padding: '24px',
                  paddingTop: `${24 + AVATAR_SIZE / 2}px`,
                  boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
                  marginTop: `${AVATAR_SIZE / 2}px`,
                }}
              >
                {/* Employee photo — sits half outside / half inside the card's top edge */}
                <div
                  style={{
                    position: 'absolute',
                    top: `-${AVATAR_SIZE / 2}px`,
                    left: '50%',
                    transform: 'translateX(-50%)',
                    width: AVATAR_SIZE,
                    height: AVATAR_SIZE,
                    borderRadius: '50%',
                    border: `${AVATAR_BORDER}px solid #fff`,
                    backgroundColor: '#fff',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    overflow: 'hidden',
                    boxShadow: '0 3px 10px rgba(0,0,0,0.2)',
                  }}
                >
                  <GetImage imgID={empid} redirect={false} width="100%" height="100%" />
                </div>

                {username && (
                  <p style={{ margin: '0 0 4px', fontWeight: 600, textAlign: 'center' }}>
                    {username}
                  </p>
                )}

                {/* Clean QR code — using QRCodeCanvas (same library approach as MeetingQR) */}
                <QRCodeCanvas
                  value={qrValue}
                  size={QR_SIZE}
                  includeMargin={true}
                  level="H"
                />
              </div>
            </div>

            <p style={{ marginTop: '4px', textAlign: 'center', color: '#555' }}>
              Your QR code is private. If you share it with someone, they can scan it to register themselves under you.
            </p>
          </>
        )}

        {!loading && !error && !qrValue && (
          <p style={{ color: '#999' }}>No data available to generate QR code.</p>
        )}
      </Modal.Body>
    </Modal>

    {(youtubevideo && istutorialinfo) && (
      <TutorialModal
        show={youtubevideo}
        hide={() => setYoutubevideo(false)}
        userid={empid}
        istutorial={istutorialinfo}
      />
    )}
    </>
  );
};

export default AddTeamQrModal;